import { ImplementationTimelineEnum } from '../interfaces';

export function calculateImplementationTimeline(
  date: string,
  today: Date,
): ImplementationTimelineEnum {
  const twoWeeksFromToday = new Date(today);
  twoWeeksFromToday.setDate(today.getDate() + 14);

  const oneMonthFromToday = new Date(today);
  oneMonthFromToday.setMonth(today.getMonth() + 1);

  const dueDate = new Date(date);

  if (dueDate < today) {
    return ImplementationTimelineEnum.overdue;
  } else if (dueDate <= twoWeeksFromToday) {
    return ImplementationTimelineEnum.immediate;
  } else if (dueDate <= oneMonthFromToday) {
    return ImplementationTimelineEnum.twoWeeks;
  } else {
    return ImplementationTimelineEnum.noRush;
  }
}
